module.exports = {
	"root": "findify-layouts--autocomplete--sidebar",
	"backdrop": "findify-layouts--autocomplete--sidebar__backdrop",
	"input": "findify-layouts--autocomplete--sidebar__input",
	"icons": "findify-layouts--autocomplete--sidebar__icons",
	"search-icon": "findify-layouts--autocomplete--sidebar__search-icon",
	"searchIcon": "findify-layouts--autocomplete--sidebar__search-icon",
	"x-icon": "findify-layouts--autocomplete--sidebar__x-icon",
	"xIcon": "findify-layouts--autocomplete--sidebar__x-icon",
	"icon-divider": "findify-layouts--autocomplete--sidebar__icon-divider",
	"iconDivider": "findify-layouts--autocomplete--sidebar__icon-divider",
	"header": "findify-layouts--autocomplete--sidebar__header",
	"type-title": "findify-layouts--autocomplete--sidebar__type-title",
	"typeTitle": "findify-layouts--autocomplete--sidebar__type-title",
	"suggestions-container": "findify-layouts--autocomplete--sidebar__suggestions-container",
	"suggestionsContainer": "findify-layouts--autocomplete--sidebar__suggestions-container",
	"suggestions-wrapper": "findify-layouts--autocomplete--sidebar__suggestions-wrapper",
	"suggestionsWrapper": "findify-layouts--autocomplete--sidebar__suggestions-wrapper",
	"body-noscroll": "findify-layouts--autocomplete--sidebar__body-noscroll",
	"bodyNoscroll": "findify-layouts--autocomplete--sidebar__body-noscroll"
};